import clsx from 'clsx';

import { RegistryTypes } from '@/react/portainer/registries/types/registry';
import { registryIconMap } from '@/react/portainer/registries/utils/constants';

import { Icon, IconSize } from '@@/Icon';

export function RegistryIcon({
  type,
  className,
  size = 'md',
}: {
  type: RegistryTypes;
  className?: string;
  size?: IconSize;
}) {
  if (type === RegistryTypes.CUSTOM || !type) {
    return (
      <div className={clsx('flex items-center', className)}>
        <Icon
          size={size}
          icon={registryIconMap[type] ?? RegistryTypes.CUSTOM}
        />
      </div>
    );
  }

  return <Icon icon={registryIconMap[type]} className={className} />;
}
